<template>
    <!-- 筛选 -->
    <ul class="nav vip-nav clearfix">
        <li class="nav-li"><router-link class="curr" to='/vipRight'><i class="icons nav-icon6 fl"></i>账号权益</router-link></li>
        <li class="nav-li" v-if="userInfo.isAdmin"><router-link class="" to='/changePassword'><i class="icons nav-icon6 fl"></i>修改密码</router-link></li>
    </ul>
</template>
<script>
import {mapState} from 'vuex';
export default {
    computed:{
        ...mapState({
            userInfo: state => state.user.userInfo,
        })
    },
    data() {
        return {
           
        }
    },
    mounted() {
		
    },
    created() {
		
    },
    methods: {
        
	}
}
</script>



// WEBPACK FOOTER //
// src/page/personalCenter/vipMenu.vue